import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  deleteOriginsApiCrud,
  type DeleteOriginsRequest,
  type DeleteOriginsResponse,
} from "@/generated/fastapi";

export async function deleteOrigins(
  accessToken: string | null | undefined,
  request: DeleteOriginsRequest,
): Promise<DeleteOriginsResponse> {
  const response = await deleteOriginsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to delete origins (${response.status})`);
  }

  if (
    response.data.status !== "success" &&
    response.data.status !== "pending" &&
    response.data.status !== "no_content"
  ) {
    throw new Error(response.data.message || "Failed to delete origins");
  }

  return response.data;
}
